import { memo } from "react";

import { BreadcrumbsPlaceholder } from "@components/Breadcrumbs";
import { type TTailwindString, tw } from "classnames";

import { CollectionHeroImagePlaceholder } from "./CollectionHeroImagePlaceholder.view";

const styles = {
  base: tw(
    "mg:flex",
    "max-w-screen-xl",
    "sm:pt-4",
    "mg:pt-12",
    "mg:px-12",
    "mx-auto"
  ),
  content: (hasHeroImage: boolean) =>
    tw(
      "flex",
      "flex-col",
      "gap-y-6",
      "mg:w-full",
      "pt-4",
      "sm:pt-6",
      "p-6",
      "mg:p-0",
      "mg:pr-10",
      {
        "pb-4": !hasHeroImage,
        "pb-6": hasHeroImage,
      }
    ),
  textContainer: tw("flex", "flex-col", "justify-center", "h-full"),
  title: tw(
    "mb-1",
    "md:mb-2",
    "h-8",
    "md:h-12",
    "w-1/2",
    "rounded-full",
    "bg-placeholder",
    "animate-pulse"
  ),
  description1: tw(
    "h-4",
    "md:h-6",
    "w-full",
    "rounded-full",
    "bg-placeholder",
    "animate-pulse",
    "mb-2"
  ),
  description2: (hasHeroImage: boolean) =>
    tw(
      "h-4",
      "md:h-6",
      "w-1/2",
      "rounded-full",
      "bg-placeholder",
      "animate-pulse",
      "md:hidden",
      "mg:block",
      {
        "mg:hidden": !hasHeroImage,
      }
    ),
  heroImageContainer: tw(
    "w-full",
    "mg:w-3/5",
    "shrink-0",
    "aspect-[1024/320]" as TTailwindString,
    "mg:aspect-[812/300]" as TTailwindString
  ),
};

type Props = {
  showHeroImage: boolean;
};

const CollectionHeroPlaceholderBase = ({ showHeroImage }: Props) => {
  return (
    <div className={styles.base}>
      <div className={styles.content(showHeroImage)}>
        <BreadcrumbsPlaceholder />
        <div className={styles.textContainer}>
          <div className={styles.title}></div>
          <div className={styles.description1}></div>
          <div className={styles.description2(showHeroImage)}></div>
        </div>
      </div>
      {showHeroImage && (
        <div className={styles.heroImageContainer}>
          <CollectionHeroImagePlaceholder />
        </div>
      )}
    </div>
  );
};

export const CollectionHeroPlaceholder = memo(CollectionHeroPlaceholderBase);
